import { useMutation } from "@tanstack/react-query";
import { forgotPassword, type ForgotPasswordRequest, type MessageResponse } from "../api/auth.api";
import { ApiError } from "@/lib/api/client";

/**
 * Mutation hook for forgot password.
 *
 * Always shows a success message (to prevent email enumeration).
 */
export function useForgotPassword() {
  return useMutation<MessageResponse, ApiError, ForgotPasswordRequest>({
    mutationFn: forgotPassword,
  });
}
